import { FC } from 'react';
import { CloseButton, CloseButtonProps } from 'components/CloseButton';

import styles from './ModalKitCloseButton.module.scss';
import clsx from 'clsx';

export const ModalKitCloseButton: FC<CloseButtonProps> = ({
  className,
  ...props
}) => {
  return (
    <CloseButton className={clsx(styles.closeButton, className)} {...props} />
  );
};
